import * as React from 'react';
import { AuthenticatedUser, UserRole } from '../../../../shared/types';
import * as ProductProperty from '../../../../shared/ProductProperties';
import { FeatureFlagKeys } from '../../../../shared/featureFlags/featureFlagKeys';
import { useFeatureFlagWithStatus } from '../../../../shared/featureFlags/useFeatureFlagWithStatus';
import ImageProcessingPage from './ImageProcessingPage';
import CustomerImageProcessingPage from './customer/entry/view/CustomerImageProcessingPage';
import ImageEditorImageProcessingPage from './imageEditor/entry/view/ImageEditorImageProcessingPage';
import { ImageEditorImageProcessingPageSkeleton } from './imageEditor/entry/view/ImageEditorImageProcessingPageSkeleton';

type ImageProcessingPageDelegateProps = {
    orderId: number;
    productProperties: any[];
    allowStitchingOfEditingImages: boolean;
    orderType: any;
    reloadData: () => void;
    user: AuthenticatedUser;
};

let SELF_EDIT_PRODUCT_PROPERTIES = [
    ProductProperty.EditCustomerImages,
    ProductProperty.EditCustomerImagesImage,
    ProductProperty.EditCustomerImagesDeluxe,
    ProductProperty.EditCustomerImagesDeluxeImage
];

let IMAGE_EDITOR_ROLES = [UserRole.ImageEditor, UserRole.ImageEditorAdmin];

export function ImageProcessingPageDelegate({
    allowStitchingOfEditingImages,
    orderId,
    productProperties,
    orderType,
    reloadData,
    user
}: ImageProcessingPageDelegateProps) {
    let imageEditorPage = useFeatureFlagWithStatus(
        FeatureFlagKeys.ImageEditorImageProcessingV2,
        false
    );
    let isSelfEditOrder =
        productProperties &&
        productProperties.some((property) => SELF_EDIT_PRODUCT_PROPERTIES.includes(property.value));

    if (user && user.details && user.details.isCustomer && !isSelfEditOrder) {
        return <CustomerImageProcessingPage user={user} orderId={orderId} />;
    }

    let isImageEditor = user && user.details && IMAGE_EDITOR_ROLES.includes(user.details.role);

    if (isImageEditor && imageEditorPage.isLoading) {
        return <ImageEditorImageProcessingPageSkeleton user={user} />;
    }

    if (isImageEditor && imageEditorPage.value) {
        return <ImageEditorImageProcessingPage user={user} orderId={orderId} />;
    }

    return (
        <ImageProcessingPage
            orderId={orderId}
            productProperties={productProperties}
            allowStitchingOfEditingImages={allowStitchingOfEditingImages}
            orderType={orderType}
            reloadData={reloadData}
        />
    );
}
